import { Button } from '@cian/ui-kit';
import { IconActionCompareAdd16, IconActionCompareAdded16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './NewbuildingComparisonButton.css';

interface INewbuildingComparisonButtonProps {
  isAdded: boolean;
  onClick(): void;
}

export const NewbuildingComparisonButton: React.FC<INewbuildingComparisonButtonProps> = ({ isAdded, onClick }) => {
  return (
    <div className={styles['container']}>
      <Button
        size="XS"
        theme="fill_secondary"
        beforeIcon={
          isAdded ? (
            <IconActionCompareAdded16 color="icon-main-default" />
          ) : (
            <IconActionCompareAdd16 color="icon-main-default" />
          )
        }
        onClick={onClick}
        data-name="NewbuildingComparisonButton"
        aria-label={isAdded ? 'Удалить из сравнения' : 'Добавить к сравнению'}
      >
        {isAdded ? 'В сравнении' : 'Сравнить'}
      </Button>
    </div>
  );
};
